module.exports = __webpack_public_path__ + "src/img/rose.png?aae2e06c244b99d7ed8b127e8575cc2e";


//////////////////
// WEBPACK FOOTER
// ./src/img/rose.png
// module id = 198
// module chunks = 0